import {FunctionComponent} from 'react'
import ReactMarkdown from 'react-markdown'
import { Grid, Paper } from '@material-ui/core';

function MarkdownToHtml(){
  return(
    <div>
    <ReactMarkdown>## Welcome to Gavin Belson Technologies - where Cutting-edge Meets Comic Relief</ReactMarkdown>

    <ReactMarkdown>### Your go-to Solution for Software Development, Hardware Design, and Casino Gaming Systems.</ReactMarkdown>
    <ReactMarkdown>Greetings! You've stumbled upon the internet's best kept secret, the playground of tech wizards with an offbeat sense of humor - Gavin Belson Technologies. Sure, we share our name with that pompous character from HBO's "Silicon Valley", but rest assured, we're the real deal. Our logo? Well, let's just say it's as edgy as the stuff we create. 
    </ReactMarkdown>

    <img src="./gb.png" alt='Gavin Belson Signature Logo' style={{width: "400px", marginLeft: "auto", marginRight: "auto", display: "block"}} />

    <ReactMarkdown>**_Boldly Going Where No Tech Firm Dares_**</ReactMarkdown>

    <ReactMarkdown>Here at Gavin Belson Technologies, we march to the beat of a different drum machine. While others are making smart toasters and AI toothbrushes (because apparently, pressing a button is too much work?), we focus on things that matter - creating innovative software solutions, designing state-of-the-art hardware concepts, and acing casino gaming systems. </ReactMarkdown>

    <ReactMarkdown>**_Innovation + Laughter = Our Mantra_**</ReactMarkdown>

    <ReactMarkdown>We believe in a world where software doesn't crash (looking at you, "Blue Screen of Death") and where hardware doesn't, well, hardwear. We're fluent in over a thousand programming languages (including Klingon, for any potential interstellar clients), and our hardware design is so cutting-edge it can be used as a kitchen knife.  </ReactMarkdown>

    <ReactMarkdown>**_DNN Training - Because Our Machines Need to Be As Smart As We Are_**</ReactMarkdown>

    <ReactMarkdown>Our AI isn't your regular artificial intelligence, it's cool artificial intelligence - because we are familiar with DNN (Deep Neural Network) training. It's like giving our machines a PhD in Smart-assery. </ReactMarkdown>

    <ReactMarkdown>**_Casino Gaming Systems - We’ve Bet It All and We’re Winning_**</ReactMarkdown>

    <ReactMarkdown>We've got a Royal Flush in our hands when it comes to Casino Gaming Systems. Whether it's a slot machine software or an all-encompassing system for your casino floor, we've got you covered. We might even throw in some betting tips (we've got a guy, don’t ask).</ReactMarkdown>

    <ReactMarkdown>**_So, Why Choose Gavin Belson Technologies?_**</ReactMarkdown>

    <ReactMarkdown>Because we know that life’s too short for boring tech. And because we’re serious about making you laugh while we blow your mind with our tech prowess. Gavin Belson Technologies - where Silicon Valley humor meets real world innovation. Join us on this wild ride, won't you?</ReactMarkdown>

    <ReactMarkdown>**Ready to change the tech game with a dash of humor? travis@lvfbody.com **</ReactMarkdown>

    <ReactMarkdown>**Disclaimer**: Any similarity with fictional characters is purely coincidental. Our Pied Piper is the sound of us coding our way to greatness.</ReactMarkdown>

    <ReactMarkdown>**_Gavin Belson Technologies_ - Seriously Funny About Tech**</ReactMarkdown>

    <ReactMarkdown>*Remember, at Gavin Belson Technologies, we don't just code - we make dreams come true. And sometimes, we also make coffee.*</ReactMarkdown>

    
    </div>
  )
}

const App: FunctionComponent<{}> = (() => {
  return (
    <Grid
      container
      spacing={0}
      alignContent="center"
      justify="center"
      direction="column">
      <Grid item>
        <Paper elevation={10} style={{padding: "20px", marginTop: "50px", width: "700px"}}>
        
        <MarkdownToHtml/>

        
        <iframe width="700" height="400" src="https://www.youtube.com/embed/6KbRA2RjhgQ" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>

        </Paper>
      </Grid>
    </Grid>
  );
})

export { App }
